import { defaultColors } from '../../../../Common/Services/contexts/ServicesChartsDataContext';
import { usePeopleChartsDataContext } from './usePeopleChartsDataContext';

const usePeopleStratificationComparison = () => {
    const { chartData } = usePeopleChartsDataContext();

    const truncate = (text, maxLength) =>
        text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

    const categories = chartData.people.map((item) =>
        truncate(item.description, 14)
    );

    const subtitles = ['Jovens', 'Adultos', 'Idosos'];

    const series = subtitles.map((item) => {
        const data = categories.map((category) => {
            const found = chartData.people.find(
                (counter) => truncate(counter.description, 14) === category
            );

            let value = 0;

            switch (item) {
                case 'Jovens':
                    value = found ? found.young : 0;
                    break;
                case 'Adultos':
                    value = found ? found.adult : 0;
                    break;
                case 'Idosos':
                    value = found ? found.elder : 0;
                    break;
                default:
                    value = 0;
                    break;
            }

            return Number(value);
        });

        return {
            name: item,
            data
        };
    });

    const chartConfig = {
        series: series,
        options: {
            chart: {
                type: 'bar',
                height: 400,
                toolbar: {
                    show: true
                }
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    columnWidth: '50%',
                    endingShape: 'rounded',
                    dataLabels: {
                        position: 'top'
                    }
                }
            },
            yaxis: {
                labels: {
                    formatter: (val) => val.toLocaleString('pt-BR')
                }
            },
            xaxis: {
                categories: categories || []
            },
            legend: {
                position: 'top',
                offsetY: 10
            },
            dataLabels: {
                enabled: true,
                formatter: (val) => `${val.toLocaleString('pt-BR')}`,
                style: {
                    colors: ['#ffffff'],
                },
                offsetX: 20,
                offsetY: 0
            },
            tooltip: {
                enabled: true,
                style: {
                    fontSize: '16px',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    fontFamily: 'Arial, sans-serif',
                    padding: '10px',
                    pointerEvents: 'auto',
                    zIndex: '1000'
                },
                y: {
                    formatter: (val) => (val ? val.toLocaleString('pt-BR') : '')
                }
            },
            colors: defaultColors,
            grid : {
                show: false,
            }
        }
    };

    return {
        chartConfig
    };
};

export default usePeopleStratificationComparison;
